/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var CorpFinAffiliateEditView = require('../../common/views/CorpFinAffiliateEditView');
var GetAffiliate = require('../../common/services/GetAffiliate');
var GetRecord = require('../../common/services/GetRecord');
var GetAllRecordLookups = require('../../common/services/GetAllRecordLookups');

module.exports = function(recordId, affiliateId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetRecord(recordId), GetAllRecordLookups(), GetAffiliate(affiliateId))
    .done(function(record, lookups, affiliate) {
      NavUtils.navigate('corpfin/registration/' + recordId + '/affiliate/' + affiliateId + '/edit');
      Scaffold.content.show(
        new CorpFinAffiliateEditView({
          viewMode: 'int',
          model: new Backbone.Model({
            recordId: recordId,
            record: record,
            affiliate: affiliate,
            affiliateId: affiliateId,
            affiliateSecondaryNameTypes: lookups.affiliateSecondaryNameTypes
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
